__turbopack_context__.v({
  "darkIcon": "ringsBackground-module__t6pm2G__darkIcon",
  "dot": "ringsBackground-module__t6pm2G__dot",
  "ellipse": "ringsBackground-module__t6pm2G__ellipse",
  "ellipse1": "ringsBackground-module__t6pm2G__ellipse1",
  "ellipse2": "ringsBackground-module__t6pm2G__ellipse2",
  "ellipse4": "ringsBackground-module__t6pm2G__ellipse4",
  "ellipse6": "ringsBackground-module__t6pm2G__ellipse6",
  "ellipse7": "ringsBackground-module__t6pm2G__ellipse7",
  "rect10": "ringsBackground-module__t6pm2G__rect10",
  "ring": "ringsBackground-module__t6pm2G__ring",
  "ringIn": "ringsBackground-module__t6pm2G__ringIn",
  "rings": "ringsBackground-module__t6pm2G__rings",
  "root": "ringsBackground-module__t6pm2G__root",
  "stage": "ringsBackground-module__t6pm2G__stage",
  "washless": "ringsBackground-module__t6pm2G__washless",
});
